import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ContactOption from './ContactOption'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import messages from './messages'
import InlineLoader from '../InlineLoader/InlineLoader'

const FootprintReveal = ({
  language,
  contactOption,
  footprintId,
  loading,
  createUserEvent
}) => {
  const translated = messages[language]
  const styles = {}

  return (
    <div>
      {loading ? (
        <InlineLoader style={styles} />
      ) : (
        <Fragment>
          <p className="footprint-id">{footprintId}</p>
          <p>{translated.footprintReveal}</p>
        </Fragment>
      )}

      <ContactOption
        option={contactOption}
        createUserEvent={createUserEvent}
        revealOverride
      />
    </div>
  )
}

FootprintReveal.propTypes = {
  language: PropTypes.string,
  contactOption: PropTypes.object,
  createUserEvent: PropTypes.func,
  footprintId: PropTypes.string,
  loading: PropTypes.bool
}

export default LanguageProvider(FootprintReveal)



// WEBPACK FOOTER //
// ./src/components/ContactUsModal/FootprintReveal.js